import { Select } from '../../../../../../baseella-ui-components/src';
import { RealMonthlyVolumeTypes } from '../types';

import cn from '../styles.module.css';

const RealMonthlyVolume = ({
  title,
  value,
  list,
  onUpdateRange,
  disabled,
}: RealMonthlyVolumeTypes): React.JSX.Element => (
  <div className={cn.realMonthlyVolume}>
    <div className={cn.realMonthlyVolumeTitle}>{title}</div>
    <div className={cn.realMonthlyVolumeValue}>
      <Select
        list={list || []}
        name="value"
        value={value || ''}
        selectWrapperClassName={`${cn.expandableRowContentSelect} ${cn.disabledSelect} ${cn.monthlyVolumeSelector}`}
        onChange={(e) => onUpdateRange(e.target.value as string)}
        disabled={disabled}
        borderless
      />
    </div>
  </div>
);

export default RealMonthlyVolume;
